import {Injectable} from '@angular/core';
import {TorchAPIConfiguration} from '../../../config/api.configuration';
import {HttpClient} from '@angular/common/http';
import {Burly} from 'kb-burly';
import {TypedPaginationResponse} from '../../../responses';
import {BehaviorSubject, Observable} from 'rxjs';
import {FuseNavigation} from '../../../../@fuse/types';
import {fuseNavigation} from '../../../../app/fuse-navigation';
import {MaintenanceItem, AppPage} from '../models';
import {map, share} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TorchMaintenanceService {

  public currentMaintenanceItem: BehaviorSubject<MaintenanceItem> = new BehaviorSubject<MaintenanceItem>(null);

  readonly navigationItems: FuseNavigation[];
  private readonly pages: AppPage[] = [];

  constructor(protected config: TorchAPIConfiguration,
              private httpClient: HttpClient) {

    this.navigationItems = fuseNavigation.map(item => this.getChildren(item))
      .reduce((accumulator, value) => accumulator.concat(value), []);

    this.pages = this.navigationItems.map(item => ({
      id: item.id,
      module: item.title,
      path: item.url,
      hidden: item.hidden || false
    }))
      .filter(item => !!item.path && !item.path.includes('admin') && item.module !== 'Dashboard');
  }

  listDisabledModules(): Observable<TypedPaginationResponse<MaintenanceItem>> {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/maintenance')
      .get;

    return this.httpClient.get<TypedPaginationResponse<MaintenanceItem>>(endpointURL);
  }

  listAvailableModules() {
    return this.listDisabledModules().pipe(
      share(),
      map(disabled => {
        const disabledPages = disabled.data.map(d => d.module);
        return this.pages.filter(page => !disabledPages.includes(page.module));
      })
    );
  }

  enableMaintenance(page: AppPage) {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/maintenance')
      .addSegment('/enable')
      .get;

    return this.httpClient.post(endpointURL, {
      module: page.module,
      route: page.path,
    });
  }

  disableMaintenance(item: MaintenanceItem) {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/maintenance')
      .addSegment('/disable')
      .addSegment(`/${item.id}`)
      .get;


    return this.httpClient.post(endpointURL, {});
  }

  updateDisabledMessage(item: MaintenanceItem, disabledMessage: string | null) {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/maintenance')
      .addSegment('/message')
      .addSegment(`/${item.id}`)
      .get;


    return this.httpClient.patch(endpointURL, {disabledMessage});
  }

  private getChildren(item: FuseNavigation): FuseNavigation[] {
    const children: FuseNavigation[] = [];

    if (!!item.children) {
      item.children.forEach(child => {
        if (child.type !== 'item') {
          children.push(...this.getChildren(child));
        } else {
          children.push(child);
        }
      });
    }

    return children;
  }
}
